// extracted by mini-css-extract-plugin
export default {"header":"tabs_header__SOj2Q","definition":"tabs_definition__NYGRC","container":"tabs_container__8XBdJ","tab":"tabs_tab__yDBN5"};